module.exports = __webpack_public_path__ + "img/手.57d5eb48.jpg";